/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { withStyles } from '@material-ui/core'
import styles from './styles'
import { CoreTextField, CoreButton } from 'src/components/core'
import { useDispatch } from 'react-redux'
import { messageBoxHideAction } from 'src/reducers/message-box/action'
import { createCollectionAction } from 'src/reducers/collection/action'

const CollectionEdit = props => {
  const { classes, onRefresh, search, sortBy } = props
  const dispatch = useDispatch()
  const [collectionName, setCollectionName] = useState('')
  const handleCreateCollection = async () => {
    if (collectionName && collectionName.trim() !== '') {
      dispatch(
        createCollectionAction({ collectionName: collectionName }, () => {
          if (onRefresh) onRefresh(search, sortBy)
        }),
      )
      dispatch(messageBoxHideAction())
    }
  }

  const handleCancel = () => {
    dispatch(messageBoxHideAction())
  }

  return (
    <div className={classes.namingModalContent}>
      <CoreTextField
        defaultValue={collectionName}
        fullWidth
        label="What's the name of your collection?"
        onChange={e => setCollectionName(e.target.value)}
        autoFocus
        onKeyPress={e => {
          if (
            e.key === 'Enter' &&
            collectionName &&
            collectionName.trim() !== ''
          ) {
            handleCreateCollection()
          }
        }}
      />
      <div className={classes.buttonContainer}>
        <CoreButton onClick={handleCancel} variant="text" color="secondary">
          Cancel
        </CoreButton>
        <CoreButton
          onClick={handleCreateCollection}
          color="primary"
          disabled={
            !collectionName ||
            collectionName.trim() === '' ||
            collectionName.length < 2
          }
        >
          Create
        </CoreButton>
      </div>
    </div>
  )
}

export default withStyles(styles)(CollectionEdit)
